module.exports = __webpack_public_path__ + "assets/img/logo-title.d527ba79.svg";